<template>
	<div class="loadingWrap">
		<div class="loading">
				<span></span>
				<span></span>
				<span></span>
				<span></span>
				<span></span>
			</div>
			<p v-html="msg">
				
			</p>
	</div>
</template>

<script>
	export default {
		name: 'loading',
		props: {
			msg: String
		},
		data() {
			return {
				
			}
		},
	
		
		mounted() {
				
		},
		methods: {
			
		},
		beforeDestroy() {
		
		}
		
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="less" scoped="scoped">
	.loadingWrap{
		position: absolute;
		width: 100%;
		height: 100%;
		background-color: rgba(255,255,255,1);
		display: flex;
		align-items: center;
		justify-content: center;
		z-index: 10;
		left: 0;
		top: 0;
		flex-direction: column;
		p{
			font-size: 24px;
			color: #333;
			line-height: 2.2em;
		}
	}
	
	.loading{
		
			height: 40px;
			margin: 20px auto;
			
		}
		.loading span{
			display: inline-block;
			width: 8px;
			height: 100%;
			border-radius: 4px;
			background: lightgreen;margin:0 5px;
			-webkit-animation: load 1s ease infinite;
			animation: load 1s ease infinite;
		}
		@-webkit-keyframes load{
			0%,100%{
				height: 40px;
				background: lightgreen;
			}
			50%{
				height: 70px;
				margin: -15px 5px;
				background: lightblue;
			}
		}
		.loading span:nth-child(2){
			-webkit-animation-delay:0.2s;
			animation-delay:0.2s;
		}
		.loading span:nth-child(3){
			-webkit-animation-delay:0.4s;
			animation-delay:0.4s;
		}
		.loading span:nth-child(4){
			-webkit-animation-delay:0.6s;
			animation-delay:0.6s;
		}
		.loading span:nth-child(5){
			-webkit-animation-delay:0.8s;
			animation-delay:0.8s;
		}
</style>
